<template>
  <div class="row spinner-parent">
    <spinner ref="spinner" size="md" text="Loading ..." />

    <div v-if="source" class="col-12">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h1>Robots Settings</h1>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card-header">
          <strong>General</strong>
        </div>
        <div class="card form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label class="col-md-2">Robots file content</label>
                  <div class="col-md-10">
                    <textarea
                      id="robots_text"
                      v-model="entity.data"
                      rows="30"
                      class="form-control"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 mb-5">
        <button class="btn btn-success" @click="save">
          Save
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Robots file was changed
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div><!--/.row-->
</template>

<script>
import _ from 'lodash';
// Mixins
import EditPageMixin from '@/mixins/EditPageMixin';

export default {
  name: 'RobotsSettings',

  mixins: [EditPageMixin],

  data() {
    return {
      source: {},
      entity: {},
    };
  },

  methods: {
    isEntityValid() {
      if (!this.entity.data) {
        this.$_errorSave('Robots file content field is required');
        return false;
      }
      return true;
    },
    getSource() {
      if (this.$refs.spinner) { this.$refs.spinner.show(); }
      this.$apiHttp.get(`${this.$config.app_api.prefix}get-robots-txt`)
        .then((response) => {
          this.source = response.data;
          this.entity = _.cloneDeep(response.data);
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
        }).catch((error) => {
          console.error('Error in get single article query', error);
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
        });
    },
    saveRequest() {
      const postFormData = new FormData();
      postFormData.append('text', this.entity.data);
      return this.$apiHttp.post(`${this.$config.app_api.prefix}save-robots-txt`, postFormData);
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(() => {
        this.$_successSave();
      }).catch((error) => {
        this.$_errorSave('Error in data saving');
        console.error('Error in create article query', error);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// Robots.vue?8fd40954